import { render, staticRenderFns } from "./CreateClientUser.vue?vue&type=template&id=941175e4&"
import script from "./CreateClientUser.vue?vue&type=script&lang=js&"
export * from "./CreateClientUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports